/*
 * @@Author: MuYang
 */
import {isUndefined} from 'lodash'
import handle from '../handle'
// 注入全局配置
const store = {
  // pretreatment,
  // schemaMap: {}, // 缓存当前组件
  componentsProps: {}, // 组件props
  handle,
  cache: {}
}

function getCache (id) {
  initStoreCatch(id)
  return store.cache[id]
}

// 向缓存中插入mapKey
function insetMap (id, mapKey, parent, key, schema) {
  const data = getCache(id)
  if (isUndefined(key)) {
    data[mapKey][parent] = schema
    return
  }
  if (isUndefined(data[mapKey][parent])) {
    data[mapKey][parent] = {}
  }
  data[mapKey][parent][key] = schema
}

//设置默认值
export function getNodeSchemaDefault (id, parent, key) {
  const data = getCache(id)
  if (isUndefined(data.schemaMap[parent])) {
    data.schemaMap[parent] = {}
  }
  if (isUndefined(data.schemaMap[parent][key])) {
    data.schemaMap[parent][key] = []
  }
  return data.schemaMap[parent][key]
}

//  插入节点
export function insetSchemaNode (id, parent, key, schema) {
  getNodeSchemaDefault(id, parent, key).push(...schema)
}

// 获取
export function getNodeSchema (id, parent, key) {
  return getNodeSchemaDefault(id, parent, key)
}

// 获取 从对象路径
export function getMasterRelationPath (id, key) {
  const data = getCache(id).tabMasterRelationMap
  return data[key]
}

// 插入 从对象路径
export function insetMasterRelationPath (id, key, path) {
  const data = getCache(id).tabMasterRelationMap
  data[key] = path
}

// 插入fieldMap
export function insetField (id, schema, parent, key) {
  insetMap(id, 'fieldMap', parent, key, schema)
}

// 插入buttonMap
export function insetButton (id, schema, parent, key) {
  insetMap(id, 'buttonMap', parent, key, schema)
}

// 插入columnMap
export function insetColumn (id, schema, parent, key) {
  insetMap(id, 'columnMap', parent, key, schema)
}

// 插入abilityMap
export function insetAbility (id, schema, parent, key) {
  insetMap(id, 'abilityMap', parent, key, schema)
}

// 插入rules
export function insetRulesMap (id, rules, key) {
  initStoreCatch(id)
  store.cache[id].rulesMap[key] = rules
}

export function initStoreCatch (id) {
  if (isUndefined(store.cache[id])) {
    store.cache[id] = {
      fieldMap: {},
      buttonMap: {},
      columnMap: {},
      schemaMap: {},
      rulesMap: {},
      abilityMap: {},
      tabMasterRelationMap: {}
    }
  }
}

export default store
